import React, {  useState  } from 'react';
import { useDispatch } from 'react-redux';


import { useUser } from '../../state/reactquery';
import { defineContratchange , modifyDisplaymodal} from '../../state/redux';
import { addEltHistory } from "../../state/reactquery";

import { axios_clients_searchclientbyid } from '../../axios/axios_clients';
import { handlephone } from "../../utils/phone";

import WindowMail from '../Email/WindowMail';

import tel from '../../images/tel.svg';
import emailing from '../../images/emailing.svg';


import './TabloContrats.scss';
       
function  TabloContrats({datas}){  

        const dispatch = useDispatch() ;
        const {data:user} = useUser(localStorage.getItem('token'))  ;
        const [showpopupmail, setShowpopupmail] =  useState(false) ;
        const [leadactu, setLeadactu] =  useState({}) ;


        const clicktel = async(idlead)=>{ addEltHistory(idlead ,'appelsortant',`<div class='horoline1' >Appel sortant par ${user.firstname} ${user.lastname} </div>` ) ;
                const reqclient = await axios_clients_searchclientbyid(idlead) ;    
                handlephone(reqclient?.data?.telephone) ;  }

                const clickmail = async(idlead)=>{
                const reqclient = await axios_clients_searchclientbyid(idlead) ;  
                setLeadactu(reqclient.data) ;    
                setShowpopupmail(true);
                }
 
        const clickline = (e,contrat)=>{ if(e.target?.classList.contains('noclickline')){return }
                dispatch(defineContratchange(contrat))  ;dispatch(modifyDisplaymodal('mod_modifcontrat'));
        }
                
                


       const linecontrat = (x)=>(<div key={x.indexe} className="tablocontrats_tablo_line cursorpointer"  onClick={(e)=>clickline(e,x)} >
                           
                                   <div>{x.nom_titulaire} {x.prenom_titulaire}</div>
                                   <div>{x.commercial}</div>
                                   <div>{new Date(x.date_signature).toLocaleDateString('fr-FR')}</div>
                                   <div>{x.compagnie}</div>
                                   <div>{parseFloat((x.prix*12)?.toFixed(2))} €</div>
                                   <div>{x.etat_contrat}</div>
                                   <div>{x.num_contrat}</div>
                              
                                   <div className="noclickline"> 
                                       <img  className="noclickline" src={tel} height="18" alt="imgtel" onClick={()=>clicktel(x.id_lead)}  />
                                   </div>
                                   <div className="noclickline"> 
                                       <img  className="noclickline" src={emailing} height="23" alt="imgemail" onClick={()=>clickmail(x.id_lead)}  />
                                   </div>
       </div>) ;



        return(<> {showpopupmail ? <WindowMail emailTo={leadactu.email}  leadactu={leadactu} closewindow={()=>setShowpopupmail(false)}  />  :
                                <div  className='tablocontrats'  >
                                                <div  className="tablocontrats_top">
                                                        <div>Nom & Prénom</div><div>Commercial</div><div>Date de signature</div>
                                                        <div>Compagnie</div><div>Prime annuelle</div>
                                                        <div>Etat du Contrat</div><div>Num. de Contrat</div>
                                                </div>   
                                                <div  id="madivscroll"  className="tablocontrats_tablo">
                                                        <div id="contentscroll"> {datas?.length > 0 && datas?.map((x)=>linecontrat(x)) }</div>
                                                </div>  
                                        </div>}</>);
   }

export default TabloContrats ;

